export const LocationMarkerSVG = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4646 33.3333C11.8147 33.3302 11.2038 33.0294 10.8158 32.5214C9.07028 30.2389 7.29543 27.6944 5.54417 24.9603C1.76102 19.0397 0 14.9778 0 12.1714C0 8.83413 1.2315 5.94127 3.66032 3.57143C6.08752 1.20159 9.0532 0 12.4744 0C15.9289 0 18.9125 1.20159 21.3405 3.57222C23.7685 5.94206 25 8.83492 25 12.1722C25 14.9794 23.239 19.0429 19.4591 24.9595C17.7078 27.6929 15.9126 30.2421 14.1223 32.5381C13.7295 33.0381 13.1202 33.3333 12.4744 33.3333H12.4646Z"
        fill="currentColor"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="34"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4646 33.3333C11.8147 33.3302 11.2038 33.0294 10.8158 32.5214C9.07028 30.2389 7.29543 27.6944 5.54417 24.9603C1.76102 19.0397 0 14.9778 0 12.1714C0 8.83413 1.2315 5.94127 3.66032 3.57143C6.08752 1.20159 9.0532 0 12.4744 0C15.9289 0 18.9125 1.20159 21.3405 3.57222C23.7685 5.94206 25 8.83492 25 12.1722C25 14.9794 23.239 19.0429 19.4591 24.9595C17.7078 27.6929 15.9126 30.2421 14.1223 32.5381C13.7295 33.0381 13.1202 33.3333 12.4744 33.3333H12.4646Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.4358 8.26279C7.33282 9.36359 6.78052 10.6533 6.78052 12.1715C6.78052 13.716 7.32713 14.9993 8.45125 16.0961C9.57619 17.1937 10.8915 17.7271 12.4735 17.7271C14.0556 17.7271 15.3709 17.1937 16.4958 16.0961C17.62 14.9985 18.1674 13.7152 18.1674 12.1715C18.1674 10.6279 17.6208 9.34374 16.4958 8.24692C15.3717 7.1493 14.0564 6.61597 12.4744 6.61597C10.9175 6.61597 9.59734 7.15486 8.4358 8.26279Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export default LocationMarkerSVG;
